import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "./ServiceDetail.module.css";
import ServiceContactForm from "../components/ServiceContactForm";
import skilledNursing from "../assets/images/skilled-nursing.png";
import physicalTherapy from "../assets/images/physical-therapy.png";
import ocupationTherapy from "../assets/images/ocupation-therapy.png";
import speechTherapy from "../assets/images/speechTherapyImg.jpg";
import socialService from "../assets/images/social-service.png";
import demantiaHelp from "../assets/images/demantia-help.png";
import geriatricCare from "../assets/images/geriatric-care.png";
import medicationReminders from "../assets/images/medication-reminders.png";
import postHospitalizationCare from "../assets/images/post-hospitalization-care.png";
import about1 from "../assets/images/about-1.png";
import about4 from "../assets/images/about4Img.jpeg";
import {
    FaUserNurse,
    FaWalking,
    FaHandHoldingHeart,
    FaComments,
    FaUsers,
    FaHome,
    FaBrain,
    FaClipboardList,
    FaPills,
    FaHospital,
    FaArrowRight,
    FaChevronLeft,
    FaChevronRight,
} from "react-icons/fa";

const SpeechTherapy = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const [isTablet, setIsTablet] = useState(window.innerWidth > 767 && window.innerWidth <= 991);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 767);
            setIsTablet(window.innerWidth > 767 && window.innerWidth <= 991);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const allServices = [
        {
            id: 1,
            title: "Skilled Nursing",
            description:
                "Registered nurses provide skilled care and instruction to patients and families, including wound care, medication supervision, catheter care, treatments and injections, and I.V. therapy.",
            image: skilledNursing,
            icon: <FaUserNurse />,
            link: "/services/skilled-nursing",
        },
        {
            id: 2,
            title: "Physical Therapy",
            description:
                "Licensed physical therapists help patients regain strength, mobility, and independence through personalized treatment plans.",
            image: physicalTherapy,
            icon: <FaWalking />,
            link: "/services/physical-therapy",
        },
        {
            id: 3,
            title: "Occupational Therapy",
            description:
                "Occupational therapists assist patients in developing, recovering, and maintaining daily living skills for improved quality of life.",
            image: ocupationTherapy,
            icon: <FaHandHoldingHeart />,
            link: "/services/occupational-therapy",
        },
        {
            id: 4,
            title: "Speech Therapy",
            description: "Speech-language pathologists help patients improve communication, swallowing difficulties, and cognitive skills.",
            image: speechTherapy,
            icon: <FaComments />,
            link: "/services/speech-therapy",
        },
        {
            id: 5,
            title: "Social Services",
            description:
                "Social workers provide counseling, community resource connections, and support for patients and families navigating healthcare challenges.",
            image: socialService,
            icon: <FaUsers />,
            link: "/services/social-services",
        },
        {
            id: 6,
            title: "Certified Home Health Aid",
            description:
                "Certified aides assist patients with personal care, meal preparation, ambulation, and exercises under professional supervision to support independent living at home.",
            image: about1,
            icon: <FaHome />,
            link: "/services/certified-home-health-aid",
        },
        {
            id: 7,
            title: "Alzheimer's Care",
            description:
                "Specialized care and support for patients with Alzheimer's disease and dementia, focusing on safety, dignity, and quality of life.",
            image: demantiaHelp,
            icon: <FaBrain />,
            link: "/services/alzheimers-care",
        },
        {
            id: 8,
            title: "Geriatric Care Management",
            description:
                "Comprehensive care coordination and advocacy services to help seniors and their families navigate complex healthcare and social service systems.",
            image: geriatricCare,
            icon: <FaClipboardList />,
            link: "/services/geriatric-care-management",
        },
        {
            id: 9,
            title: "Medication Reminders",
            description:
                "Professional medication management services to ensure proper medication adherence and prevent missed doses or dangerous interactions.",
            image: medicationReminders,
            icon: <FaPills />,
            link: "/services/medication-reminders",
        },
        {
            id: 10,
            title: "Post-hospitalization Care",
            description:
                "Transitional care services to support safe recovery at home after hospital discharge, reducing readmission risks and promoting healing.",
            image: postHospitalizationCare,
            icon: <FaHospital />,
            link: "/services/post-hospitalization-care",
        },
    ];

    const relatedServices = allServices.filter((service) => service.id !== 4);

    const getMaxIndex = () => {
        if (isMobile) return relatedServices.length - 1;
        if (isTablet) return relatedServices.length - 2;
        return relatedServices.length - 3;
    };

    useEffect(() => {
        const maxIndex = getMaxIndex();
        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
        }, 5000);
        return () => clearInterval(interval);
    }, [isMobile, isTablet, relatedServices.length]);

    const nextSlide = () => {
        const maxIndex = getMaxIndex();
        setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
    };

    const prevSlide = () => {
        const maxIndex = getMaxIndex();
        setCurrentIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
    };

    return (
        <div className={styles.serviceDetailPage}>
            <section className={styles.heroSection}>
                <div className={styles.heroContainer}>
                    <div className={styles.heroContent}>
                        <div className={styles.iconBadge}>
                            <FaComments />
                        </div>
                        <p className={styles.heroTag}>SENIOR CARE SERVICES</p>
                        <h1 className={styles.heroTitle}>Speech Therapy</h1>
                        <p className={styles.heroDescription}>
                            Expert speech-language pathology services to help improve communication, address swallowing difficulties, and enhance
                            cognitive-linguistic skills through personalized therapy sessions in your home.
                        </p>
                        <Link to="/contact" className={styles.heroButton}>
                            Get Started
                        </Link>
                    </div>
                    <div className={styles.heroImageContainer}>
                        <img src={about4} alt="Speech Therapy" className={styles.heroImage} />
                    </div>
                </div>
            </section>

            <section className={styles.includedSection}>
                <div className={styles.container}>
                    <div className={styles.includedGrid}>
                        <div className={styles.includedContent}>
                            <h2 className={styles.sectionTitle}>What's included in the service?</h2>
                            <p className={styles.includedText}>
                                Our speech therapy services provide comprehensive assessment and treatment to address communication, swallowing, and
                                cognitive-linguistic challenges. Each program is tailored to your unique needs and goals.
                            </p>
                            <ul className={styles.includedList}>
                                <li>Comprehensive speech and language assessment</li>
                                <li>Articulation and phonological therapy</li>
                                <li>Language therapy for expression and comprehension</li>
                                <li>Voice therapy and vocal quality improvement</li>
                                <li>Swallowing evaluation and dysphagia management</li>
                                <li>Cognitive-linguistic therapy for memory and problem-solving</li>
                                <li>Augmentative and alternative communication (AAC) devices</li>
                                <li>Aphasia therapy following stroke or brain injury</li>
                                <li>Fluency therapy for stuttering</li>
                                <li>Caregiver training and communication strategies</li>
                            </ul>
                        </div>
                        <div className={styles.includedImage}>
                            <img src={speechTherapy} alt="Speech Therapy" />
                        </div>
                    </div>
                </div>
            </section>

            <section className={styles.aboutSection}>
                <div className={styles.container}>
                    <div className={styles.aboutGrid}>
                        <div className={styles.aboutContent}>
                            <h2 className={styles.sectionTitle}>About this service</h2>
                            <p className={styles.aboutText}>
                                Our Speech Therapy services are provided by licensed speech-language pathologists who specialize in helping
                                individuals overcome communication challenges, swallowing difficulties, and cognitive-linguistic impairments. We work
                                with patients of all ages who are experiencing speech, language, voice, or swallowing disorders.
                            </p>
                            <p className={styles.aboutText}>
                                Whether you're recovering from a stroke, managing a progressive neurological condition, or working to improve
                                communication skills, our therapists develop personalized treatment plans that address your specific needs. We focus
                                on improving your ability to communicate effectively and safely manage eating and drinking in the comfort of your
                                home.
                            </p>
                        </div>
                        <div className={styles.contactCard}>
                            <h3 className={styles.contactTitle}>Get in contact with us!</h3>
                            <p className={styles.contactText}>
                                Ready to improve your communication and swallowing abilities? Contact us today to schedule a speech therapy
                                evaluation.
                            </p>
                            <ServiceContactForm serviceName="Speech Therapy" serviceType="Speech Therapy Consultation" />
                        </div>
                    </div>
                </div>
            </section>

            <section className={styles.moreServicesSection}>
                <div className={styles.container}>
                    <div className={styles.moreServicesHeader}>
                        <h2 className={styles.sectionTitle}>More services</h2>
                        <Link to="/services" className={styles.browseButton}>
                            Browse services
                        </Link>
                    </div>
                    <div className={styles.sliderWrapper}>
                        <button className={styles.navButton + " " + styles.navButtonPrev} onClick={prevSlide} aria-label="Previous services">
                            <FaChevronLeft />
                        </button>
                        <div className={styles.sliderContainer}>
                            <div
                                className={styles.servicesSlider}
                                style={{
                                    transform: `translateX(-${currentIndex * (isMobile ? 100 : isTablet ? 50 : 33.333)}%)`,
                                    transition: "transform 0.5s ease-in-out",
                                }}
                            >
                                {relatedServices.map((service) => (
                                    <div key={service.id} className={styles.slideItem}>
                                        <Link to={service.link} className={styles.serviceCard}>
                                            <div className={styles.serviceImageContainer}>
                                                <img src={service.image} alt={service.title} className={styles.serviceImage} />
                                                <div className={styles.serviceIconBadge}>{service.icon}</div>
                                            </div>
                                            <div className={styles.serviceContent}>
                                                <h3 className={styles.serviceTitle}>{service.title}</h3>
                                                <p className={styles.serviceDescription}>{service.description}</p>
                                                <div className={styles.serviceLink}>
                                                    <span>View service</span>
                                                    <FaArrowRight />
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <button className={styles.navButton + " " + styles.navButtonNext} onClick={nextSlide} aria-label="Next services">
                            <FaChevronRight />
                        </button>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default SpeechTherapy;
